import React from 'react';

export default class ContextHelpText extends React.PureComponent {
  render() {
    const {department, profiles, profileName} = this.props;
    return profiles.size === 0 ? (
      <p>
        Click New {profileName} Profile to configure a new profile, which you can optionally select
        for <strong>{department.name}</strong>.
      </p>
    ) : (
      <p>
        Click "Select" to choose a profile for <strong>{department.name}</strong>, or click New{' '}
        {profileName} Profile to make a new profile for the department.
      </p>
    );
  }
}
